import { useState, useEffect } from "react";
import { Routes, Route, useLocation } from "react-router-dom";

import HomePage from "./pages/HomePage";
import GalleryPage from "./pages/GalleyPage";
import ChrisMedhaGallery from "./pages/ChrisMedhaGallery";
import FashionGallery from "./pages/FashionGallery";
import VyshnaviAniGallery from "./pages/VyshnaviAniGallery";
import BennyVyshnavi from "./pages/BennyVyshnavi";
import Toddlers from "./pages/Toddlers";
import WeddingGallery from "./pages/WeddingGallery";
import Admin from "./pages/Admin";
import ClientGallery from "./pages/ClientGallery";
import WeddingDetail from "./pages/WeddingDetail";
import ScrollToTop from "./components/ScrollToTop";

// 🎬 Loading Animation Component
const LoadingAnimation = ({ onComplete }) => {
  return (
    <div
      style={{
        width: "100vw",
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "black",
      }}
    >
      <video
        autoPlay
        muted
        playsInline
        onEnded={onComplete}
        style={{
          width: "100%",
          maxWidth: "calc(100vh * 16 / 9)",
          height: "auto",
          maxHeight: "100vh",
          aspectRatio: "16 / 9",
        }}
      >
        <source src="/assets/loading.mp4" type="video/mp4" />
        Your browser does not support the video tag.
      </video>
    </div>
  );
};


const App = () => {
  const location = useLocation();
  const [loading, setLoading] = useState(true);

  // ✅ Only homepage should show loader
  const isHomePage =
    location.pathname === "/" || location.pathname === "/home";

  useEffect(() => {
    if (isHomePage) {
      setLoading(true);   // show loader when visiting homepage
    } else {
      setLoading(false);  // skip loader for all other pages
    }
  }, [location.pathname, isHomePage]);

  const handleLoadingComplete = () => {
    setLoading(false);
  };

  return (
    <>
      <ScrollToTop />
      {/* 🔄 Loader only on Home */}
      {isHomePage && loading && (
        <LoadingAnimation onComplete={handleLoadingComplete} />
      )}

      {/* 🌐 Routes */}
      {(!isHomePage || !loading) && (
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/home" element={<HomePage />} />

          <Route path="/gallery" element={<GalleryPage />} />
          <Route path="/gallery/wedding" element={<WeddingGallery />} />
          <Route path="/gallery/fashion" element={<FashionGallery />} />

          <Route
            path="/gallery/wedding/chris-medha"
            element={<ChrisMedhaGallery />}
          />
          <Route
            path="/gallery/wedding/vyshanavie-anirudh"
            element={<VyshnaviAniGallery />}
          />
          <Route
            path="/gallery/wedding/benny-vaishnavi"
            element={<BennyVyshnavi />}
          />

          <Route path="/gallery/toddler" element={<Toddlers />} />

          <Route path="/admin" element={<Admin />} />

          <Route path="/client-gallery" element={<ClientGallery />} />
          <Route
            path="/client-gallery/:category"
            element={<ClientGallery />}
          />

          <Route
            path="/gallery-detail/:galleryName"
            element={<WeddingDetail />}
          />
          <Route
            path="/gallery-detail/:galleryName/:category"
            element={<WeddingDetail />}
          />
        </Routes>
      )}
    </>
  );
};

export default App;